import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Advertisment from './advertisment';
import AdvertismentDetail from './advertisment-detail';
import AdvertismentUpdate from './advertisment-update';
import AdvertismentDeleteDialog from './advertisment-delete-dialog';

const AdvertismentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Advertisment />} />
    <Route path="new" element={<AdvertismentUpdate />} />
    <Route path=":id">
      <Route index element={<AdvertismentDetail />} />
      <Route path="edit" element={<AdvertismentUpdate />} />
      <Route path="delete" element={<AdvertismentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AdvertismentRoutes;
